import { CosmosGovV1Gov } from '@injectivelabs/core-proto-ts';
export const VoteOptionMap = CosmosGovV1Gov.VoteOption;
export const ProposalStatusMap = CosmosGovV1Gov.ProposalStatus;
